import { useToast } from "vue-toastification"
import Helper from "@/services/Helper"
import Err from "@/services/err/Err"

export default class NotifyBase {
    static success(msg) {
        const toast = useToast()

        toast.success(msg, {
            timeout: 3500
        });
    }

    static info(msg) {
        const toast = useToast()

        toast.info(msg, {
            timeout: 3500
        });
    }

    static error(msg, payload) {
        const toast= useToast()

        let method = payload?.config?.method
        let url = payload?.config?.url

        if (method && url) {
            let key = Helper.md5(url + method)
            Err.rm(key)
        }

        toast.error(msg, {
            timeout: 4000
        });
    }
}
